module.exports = __webpack_public_path__ + "img/chang.8b4bd110.png";